// extracted by mini-css-extract-plugin
export default {"base":"Progress_base__Lz-E2","stripes":"Progress_stripes__fE3Or","move-stripes":"Progress_move-stripes__CQOYs"};